const url = sessionStorage.baseUrl

console.log("URL: "+url);

//export const baseUrl =   "http://localhost:3001/" //url

//Default database URL base